var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00049 1.3335C11.6803 1.33367 14.6665 4.3206 14.6665 8.00049C14.6663 11.6802 11.6802 14.6663 8.00049 14.6665C4.3206 14.6665 1.33367 11.6803 1.3335 8.00049C1.3335 4.32049 4.32049 1.3335 8.00049 1.3335ZM7.3335 11.3335H8.6665V10.0005H7.3335V11.3335ZM7.3335 4.6665V8.6665H8.6665V4.6665H7.3335Z",
    fill: "#F04141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningFilled);
export default __webpack_public_path__ + "static/media/warning_filled.825e0f7005e80797b62cfbb370ac8dd7.svg";
export { ForwardRef as ReactComponent };